import {
  faBookmark,
  faCartShopping,
  faChartSimple,
  faGear,
  faHome,
  faRightFromBracket,
  faSquare,
  faUser,
  faChartLine,
  faArrowAltCircleUp,
  faSignal,
  faGaugeSimpleHigh,
  faFileLines,
  faMicrophone,
  faDatabase,
  faHandshake,
  faFileAlt,
  faTruck,

} from '@fortawesome/free-solid-svg-icons';

import { environment } from 'src/environments/environment';
import { isLoggedIn } from 'src/app/services/rx-auth/rx-auth.service';

export interface ParamOptions {
  search?: string;
  view?: string;
  id?: number;
}

export interface NavigationOption {
  title: string;
  icon: any; // Typings say it should be IconDefinition, but TypeScript error says otherwise within the sidebar nav's HTML template.
  route: string | null;
  params?: ParamOptions | null;
  externalUrl?: string; // Added field for external URLs
  children?: NavigationOption[];
  separator?:boolean,
  disabled?:boolean,
}

function hideBarometer(): boolean {
  return false
}

export const desktopMenuOptions: NavigationOption[] = [

  {
    title: 'Home',
    icon: faHome,
    route: null,
    externalUrl: `${environment.wp.frontend_base}`,
  },
  {
    title: 'Rankings',
    icon: faSignal,
    route: '/explore',
    params: { search: '', view: 'lists' },
  },
  {
    title: 'Retailers',
    icon: faCartShopping,
    route: '/explore',
    params: { search: '', view: 'retailers' },
  },
  {
    title: 'Suppliers',
    icon: faTruck,
    route: '/explore',
    params: { search: '', view: 'suppliers' },
  },
  {
    title: 'Saved Charts',
    icon: faBookmark,
    route: '/saved-charts',
  },
  {
    title: 'Leadership',
    icon: faArrowAltCircleUp,
    route: hideBarometer() ? null : '/leadership-barometer/LB-2024-H2',
    disabled: hideBarometer()
  },
  {
    title: 'Reports',
    icon: faFileAlt,
    route: null,
    externalUrl: `${environment.wp.frontend_base}reports`,
  },
  {
    title: 'Data Packs',
    icon: faDatabase,
    route: null,
    externalUrl: `${environment.wp.frontend_base}datapacks`,
  },
  {
    title: 'Podcasts',
    icon: faMicrophone,
    route: null,
    externalUrl: `${environment.wp.frontend_base}podcasts`,
  },
  {
    title: 'Partners',
    icon: faHandshake,
    separator:true,
    route: null,
     externalUrl: `${environment.wp.frontend_base}partners`,
  },
  {
    title: 'My account',
    icon: faUser,
    route: null,
    externalUrl: `${environment.wp.frontend_base}myaccount`,
  },
  {
    title: isLoggedIn() ? 'Log out' : 'Log in',
    icon: faRightFromBracket,
    route: isLoggedIn() ? '/logout' : '/logout',
  },
];
